(function () {
  "use strict";
  window.MissEarringsCatalog = {
  "version": "v96-independent-models",
  "groupCount": 48,
  "skuCount": 90,
  "approvedSkus": [
    "12C",
    "12P",
    "12S",
    "12SP",
    "12V",
    "13B",
    "13P",
    "13S",
    "13SB",
    "13SP",
    "14B",
    "14BT",
    "14FB",
    "14FP",
    "14H",
    "14S",
    "14SP",
    "15BTP",
    "15H",
    "15HP",
    "15RAR",
    "17L",
    "17RA",
    "1B",
    "1C",
    "1CB",
    "1CP",
    "22S",
    "23B",
    "23N",
    "23S",
    "23SB",
    "23SP",
    "24B",
    "24BT",
    "24F",
    "24FB",
    "24FP",
    "24N",
    "24S",
    "24SL",
    "2B",
    "2C",
    "2CB",
    "2CP",
    "33B",
    "43B",
    "44C",
    "44S",
    "A01",
    "AR1",
    "AR2",
    "B13",
    "C01",
    "E01",
    "E03",
    "E04",
    "E12",
    "E13",
    "E17",
    "F09",
    "F21",
    "F55",
    "H10",
    "H14",
    "M03",
    "M13",
    "M18",
    "N04",
    "N06",
    "N07",
    "N13",
    "O01",
    "S110",
    "S116",
    "S118",
    "S119",
    "S50",
    "S51",
    "S76",
    "S89",
    "U01",
    "Z10",
    "Z14",
    "Z19",
    "Z24",
    "Z33",
    "Z47",
    "Z49",
    "Z61"
  ],
  "groups": [
    {
      "model": "Pavé Star",
      "style": "elegantes estrellas",
      "audience": "adulto nina",
      "shaft": "1,2",
      "order": 0,
      "variants": [
        {
          "sku": "E12",
          "name": "Snow Star",
          "displayName": "Snow Star · Pavé Star · Crystal",
          "color": "Crystal",
          "colorTerms": "cristal plateado",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#E4E9EE",
          "material": "acero",
          "millimetres": "8",
          "publicCents": 1800,
          "expo": false,
          "expoOrder": 999,
          "search": "e12 estrella nieve estrella cristal estrella pave 8 mm. acero inoxidable . laminado en oro 24k. circonita cubica. cristal. plateado estrella pave",
          "primaryAsset": "miss-v68-e12-primary.webp",
          "alternateAsset": "miss-v68-e12-alternate.webp"
        }
      ]
    },
    {
      "model": "Pearl Star",
      "style": "elegantes estrellas",
      "audience": "adulto nina",
      "shaft": "1,2",
      "order": 1,
      "variants": [
        {
          "sku": "E13",
          "name": "Astrea",
          "displayName": "Astrea · Pearl Star · Golden",
          "color": "Gold",
          "colorTerms": "dorado perla",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#C9A254",
          "material": "oro24k",
          "millimetres": "9",
          "publicCents": 2000,
          "expo": false,
          "expoOrder": 999,
          "search": "e13 astrea estrella perla dorado estrella perla 9 mm. acero inoxidable . laminado en oro 24k. perla. cristal. oro 24k estrella perla",
          "primaryAsset": "miss-v68-e13-primary.webp",
          "alternateAsset": "miss-v68-e13-alternate.webp"
        }
      ]
    },
    {
      "model": "Butterfly",
      "style": "animales elegantes",
      "audience": "adulto nina",
      "shaft": "1,2",
      "order": 2,
      "variants": [
        {
          "sku": "M13",
          "name": "Butterfly",
          "displayName": "Butterfly · Butterfly · Crystal",
          "color": "Crystal",
          "colorTerms": "cristal dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#E4E9EE",
          "material": "oro24k",
          "millimetres": "5",
          "publicCents": 2000,
          "expo": false,
          "expoOrder": 999,
          "search": "m13 mariposa circonita mariposa cristal mariposa 5 mm. acero inoxidable . laminado en oro 24k. circonita cubica. cristal. oro 24k mariposa",
          "primaryAsset": "miss-v68-m13-primary.webp",
          "alternateAsset": "miss-v68-m13-alternate.webp"
        }
      ]
    },
    {
      "model": "Butterfly",
      "style": "animales elegantes",
      "audience": "adulto nina",
      "shaft": "1,2",
      "order": 3,
      "variants": [
        {
          "sku": "M18",
          "name": "Crystal Butterfly",
          "displayName": "Crystal Butterfly Butterfly Crystal",
          "color": "Crystal",
          "colorTerms": "cristal plateado",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#E4E9EE",
          "material": "acero",
          "millimetres": "5",
          "publicCents": 1800,
          "expo": false,
          "expoOrder": 999,
          "search": "m18 mariposa circonita mariposa cristal mariposa 5 mm. acero inoxidable . circonita cubica. cristal. plateado mariposa",
          "primaryAsset": "miss-v68-m18-primary.webp",
          "alternateAsset": "miss-v68-m18-alternate.webp"
        }
      ]
    },
    {
      "model": "Smooth Hoop",
      "style": "aros basicos",
      "audience": "adulto",
      "shaft": "1,2",
      "order": 4,
      "variants": [
        {
          "sku": "AR1",
          "name": "Steel Hoop",
          "displayName": "Steel Hoop Smooth Hoop Silver",
          "color": "Silver",
          "colorTerms": "plateado",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#C4C9CF",
          "material": "acero",
          "millimetres": "10",
          "publicCents": 2400,
          "expo": false,
          "expoOrder": 999,
          "search": "ar1 aro acero aro liso plateado 10 mm acero inoxidable hipoalergenico cierre bisagra",
          "primaryAsset": "miss-v68-ar01-primary.webp",
          "alternateAsset": "miss-v68-ar01-alternate.webp"
        },
        {
          "sku": "AR2",
          "name": "Classic Hoop",
          "displayName": "Classic Hoop · Smooth Hoop · 24K Gold",
          "color": "24K Gold",
          "colorTerms": "dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#C9A254",
          "material": "oro24k",
          "millimetres": "10",
          "publicCents": 2400,
          "expo": false,
          "expoOrder": 999,
          "search": "ar2 aro clasico aro liso oro 24k dorado 10 mm acero inoxidable laminado en oro 24k hipoalergenico cierre bisagra",
          "primaryAsset": "miss-v68-ar02-primary.webp",
          "alternateAsset": "miss-v68-ar02-alternate.webp"
        }
      ]
    },
    {
      "model": "Pavé Apple",
      "style": "elegantes infantiles",
      "audience": "adulto nina",
      "shaft": "1,2",
      "order": 5,
      "variants": [
        {
          "sku": "U01",
          "name": "Snow White",
          "displayName": "Snow White · Pavé Apple · Red Crystal",
          "color": "red crystal",
          "colorTerms": "cristal plateado rojo",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#C8102E",
          "material": "acero",
          "millimetres": "8",
          "publicCents": 1800,
          "expo": false,
          "expoOrder": 999,
          "search": "u01 blancanieves manzana cristal rojo manzana pave 8 mm. acero inoxidable . cristal rojo. plateado manzana pave",
          "primaryAsset": "miss-v68-u01-primary.webp",
          "alternateAsset": "miss-v68-u01-alternate.webp"
        }
      ]
    },
    {
      "model": "Cherries",
      "style": "infantiles",
      "audience": "nina",
      "shaft": "1,2",
      "order": 6,
      "variants": [
        {
          "sku": "C01",
          "name": "Ibiza",
          "displayName": "Ibiza · Cherries · Red",
          "color": "Red",
          "colorTerms": "dorado multicolor rojo verde",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#C8102E",
          "material": "oro24k",
          "millimetres": "7",
          "publicCents": 2000,
          "expo": false,
          "expoOrder": 999,
          "search": "c01 ibiza cereza rojo cerezas 7 mm. acero inoxidable . laminado en oro 24k. rojo y verde. oro 24k cerezas",
          "primaryAsset": "miss-v68-c01-primary.webp",
          "alternateAsset": "miss-v68-c01-alternate.webp"
        }
      ]
    },
    {
      "model": "Relief Bear",
      "style": "animales infantiles",
      "audience": "nina",
      "shaft": "1,2",
      "order": 7,
      "variants": [
        {
          "sku": "O01",
          "name": "Ruby Bear",
          "displayName": "Ruby Bear · Embossed Bear · Gold + Red",
          "color": "Gold + Red",
          "colorTerms": "dorado rojo",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "linear-gradient(135deg,#C9A254 0 50%,#C8102E 50% 100%)",
          "material": "oro24k",
          "millimetres": "6",
          "publicCents": 2000,
          "expo": false,
          "expoOrder": 999,
          "search": "o01 osito rubi oso dorado + rojo oso relieve 6 mm. acero inoxidable . laminado en oro 24k. dorado y rojo. oro 24k oso relieve",
          "primaryAsset": "miss-v68-o01-primary.webp",
          "alternateAsset": "miss-v68-o01-alternate.webp"
        }
      ]
    },
    {
      "model": "Enameled Butterfly",
      "style": "animales",
      "audience": "nina",
      "shaft": "1,2",
      "order": 8,
      "variants": [
        {
          "sku": "15BTP",
          "name": "Pink Butterfly",
          "displayName": "Rosé Butterfly · Enameled Butterfly · Pink",
          "color": "Pink",
          "colorTerms": "dorado rosa",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#F09AB9",
          "material": "oro24k",
          "millimetres": "7",
          "publicCents": 2000,
          "expo": true,
          "expoOrder": 20,
          "search": "15btp mariposa rose mariposa rosa mariposa esmaltada 7 mm. acero inoxidable . laminado en oro 24k. rosa. oro 24k mariposa esmaltada",
          "primaryAsset": "miss-v68-15btp-primary.webp",
          "alternateAsset": "miss-v68-15btp-alternate.webp"
        }
      ]
    },
    {
      "model": "Rabbit Relief",
      "style": "animales infantiles",
      "audience": "nina",
      "shaft": "1,2",
      "order": 9,
      "variants": [
        {
          "sku": "17RA",
          "name": "Honey Bunny",
          "displayName": "Honey Bunny · Embossed Rabbit · Golden",
          "color": "Gold",
          "colorTerms": "dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#C9A254",
          "material": "oro24k",
          "millimetres": "8",
          "publicCents": 2000,
          "expo": true,
          "expoOrder": 17,
          "search": "17ra conejito miel conejo dorado conejo relieve 8 mm. acero inoxidable . laminado en oro 24k. oro 24k conejo relieve",
          "primaryAsset": "miss-v68-17ra-primary.webp",
          "alternateAsset": "miss-v68-17ra-alternate.webp"
        }
      ]
    },
    {
      "model": "Butterfly Birthstone",
      "style": "animales elegantes",
      "audience": "adulto nina",
      "shaft": "1,2",
      "order": 10,
      "variants": [
        {
          "sku": "M03",
          "name": "Aqua Butterfly",
          "displayName": "Aqua Butterfly · Butterfly · Birthstone · March · Aquamarine",
          "color": "March · Aquamarine",
          "colorTerms": "azul plateado",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#86CFE6",
          "material": "acero",
          "millimetres": "6",
          "publicCents": 1800,
          "expo": false,
          "expoOrder": 999,
          "search": "m03 mariposa aqua mariposa marzo · aguamarina mariposa - marzo (piedra de nacimiento) -6 mm. acero inoxidable . aguamarina. plateado mariposa · piedra de nacimiento",
          "primaryAsset": "miss-v68-m03-primary.webp",
          "alternateAsset": "miss-v68-m03-alternate.webp"
        },
        {
          "sku": "24BT",
          "name": "April Butterfly",
          "displayName": "April Butterfly · Butterfly · Birthstone · April · Crystal",
          "color": "April Crystal",
          "colorTerms": "cristal plateado",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#E4E9EE",
          "material": "acero",
          "millimetres": "6",
          "publicCents": 1800,
          "expo": true,
          "expoOrder": 33,
          "search": "24bt mariposa abril mariposa abril · cristal mariposa - abril (piedra de nacimiento) -6 mm. acero inoxidable . cristal. plateado mariposa · piedra de nacimiento",
          "primaryAsset": "miss-v68-24bt-primary.webp",
          "alternateAsset": "miss-v68-24bt-alternate.webp"
        }
      ]
    },
    {
      "model": "Enameled Heart",
      "style": "corazones",
      "audience": "nina",
      "shaft": "1,2",
      "order": 11,
      "variants": [
        {
          "sku": "15H",
          "name": "Ruby Heart",
          "displayName": "Ruby Heart Enameled Heart Red",
          "color": "Red",
          "colorTerms": "dorado rojo",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#C8102E",
          "material": "oro24k",
          "millimetres": "5",
          "publicCents": 2000,
          "expo": false,
          "expoOrder": 999,
          "search": "15h corazon rubi corazon rojo corazon esmaltado 5 mm. acero inoxidable . laminado en oro 24k. rojo. oro 24k corazon esmaltado",
          "primaryAsset": "miss-v68-15h-primary.webp",
          "alternateAsset": "miss-v68-15h-alternate.webp"
        },
        {
          "sku": "15HP",
          "name": "Pink Heart",
          "displayName": "Rosé Heart Enameled Heart Pink",
          "color": "Pink",
          "colorTerms": "dorado rosa",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#F09AB9",
          "material": "oro24k",
          "millimetres": "5",
          "publicCents": 2000,
          "expo": true,
          "expoOrder": 18,
          "search": "15hp corazon rose corazon rosa corazon esmaltado 5 mm. acero inoxidable . laminado en oro 24k. rosa. oro 24k corazon esmaltado",
          "primaryAsset": "miss-v68-15hp-primary.webp",
          "alternateAsset": "miss-v68-15hp-alternate.webp"
        }
      ]
    },
    {
      "model": "crystal star",
      "style": "elegantes estrellas",
      "audience": "adulto nina",
      "shaft": "1,2",
      "order": 12,
      "variants": [
        {
          "sku": "E03",
          "name": "Gala Star",
          "displayName": "Gala Star Crystal Star Crystal",
          "color": "Crystal",
          "colorTerms": "cristal dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#E4E9EE",
          "material": "oro24k",
          "millimetres": "5",
          "publicCents": 2000,
          "expo": false,
          "expoOrder": 999,
          "search": "e03 estrella gala estrella cristal estrella cristal 5 mm. acero inoxidable . laminado en oro 24k. cristal. oro 24k estrella cristal",
          "primaryAsset": "miss-v68-e03-primary.webp",
          "alternateAsset": "miss-v68-e03-alternate.webp"
        },
        {
          "sku": "E04",
          "name": "Pink Star",
          "displayName": "Pink Star Crystal Star Pink",
          "color": "Pink",
          "colorTerms": "cristal dorado rosa",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#F09AB9",
          "material": "oro24k",
          "millimetres": "5",
          "publicCents": 2000,
          "expo": false,
          "expoOrder": 999,
          "search": "e04 estrella rosa estrella rosa estrella cristal 5 mm. acero inoxidable . laminado en oro 24k. rosa. oro 24k estrella cristal",
          "primaryAsset": "miss-v68-e04-primary.webp",
          "alternateAsset": "miss-v68-e04-alternate.webp"
        }
      ]
    },
    {
      "model": "flower",
      "style": "elegantes flores",
      "audience": "adulto nina",
      "shaft": "1,2",
      "order": 13,
      "variants": [
        {
          "sku": "24FB",
          "name": "Sapphire Flower",
          "displayName": "Sapphire Flower · Flower · Crystal + Sapphire Blue",
          "color": "Crystal + Sapphire Blue",
          "colorTerms": "azul cristal plateado",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "linear-gradient(135deg,#E4E9EE 0 50%,#24479E 50% 100%)",
          "material": "acero",
          "millimetres": "4",
          "publicCents": 1800,
          "expo": true,
          "expoOrder": 29,
          "search": "24fb flor zafiro flor cristal + azul zafiro flor 4 mm. acero inoxidable . petalos cristal. centro azul zafiro. plateado flor",
          "primaryAsset": "miss-v68-24fb-primary.webp",
          "alternateAsset": "miss-v68-24fb-alternate.webp"
        },
        {
          "sku": "24FP",
          "name": "Aurora Flower",
          "displayName": "Flower Aurora Flower Aurora Borealis",
          "color": "Aurora Borealis",
          "colorTerms": "cristal multicolor plateado",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "conic-gradient(from 210deg,#F3BCC8,#F7E5A6,#C3E5CB,#BCDAF1,#DAC7EE,#F3BCC8)",
          "material": "acero",
          "millimetres": "5",
          "publicCents": 1800,
          "expo": true,
          "expoOrder": 30,
          "search": "24fp flor aurora flor aurora boreal flor 5 mm. acero inoxidable . petalos multicolor. centro cristal. plateado flor",
          "primaryAsset": "miss-v68-24fp-primary.webp",
          "alternateAsset": "miss-v68-24fp-alternate.webp"
        }
      ]
    },
    {
      "model": "Pavé Dragonfly",
      "style": "animales elegantes",
      "audience": "adulto nina",
      "shaft": "1,2",
      "order": 14,
      "variants": [
        {
          "sku": "17L",
          "name": "Dragonfly",
          "displayName": "Dragonfly Pavé Dragonfly Crystal",
          "color": "Crystal",
          "colorTerms": "cristal dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#E4E9EE",
          "material": "oro24k",
          "millimetres": "8",
          "publicCents": 2000,
          "expo": true,
          "expoOrder": 13,
          "search": "17l libelula libelula cristal libelula pave 8 mm. acero inoxidable . laminado en oro 24k. circonita cubica. cristal. oro 24k libelula pave",
          "primaryAsset": "miss-v68-17l-primary.webp",
          "alternateAsset": "miss-v68-17l-alternate.webp"
        }
      ]
    },
    {
      "model": "Rabbit Button",
      "style": "basicos",
      "audience": "adulto",
      "shaft": "1,2",
      "order": 15,
      "variants": [
        {
          "sku": "15RAR",
          "name": "Ruby Bunny",
          "displayName": "Ruby Bunny · Rabbit Button · Red",
          "color": "Red",
          "colorTerms": "plateado rojo",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#C8102E",
          "material": "acero",
          "millimetres": "5",
          "publicCents": 1800,
          "expo": true,
          "expoOrder": 34,
          "search": "15rar conejito rubi boton rojo boton conejo 5 mm. acero inoxidable . rojo. plateado boton conejo",
          "primaryAsset": "miss-v68-15rar-primary.webp",
          "alternateAsset": "miss-v68-15rar-alternate.webp"
        }
      ]
    },
    {
      "model": "Flat Button",
      "style": "basicos",
      "audience": "adulto",
      "shaft": "1,2",
      "order": 16,
      "variants": [
        {
          "sku": "N13",
          "name": "Onyx",
          "displayName": "Onyx Flat Button Black",
          "color": "Black",
          "colorTerms": "negro",
          "finish": "Black",
          "finishDot": "#3A3A3A",
          "swatch": "#17171A",
          "material": "acero",
          "millimetres": "5",
          "publicCents": 1800,
          "expo": false,
          "expoOrder": 999,
          "search": "n13 onix boton negro boton plano 5 mm. acero inoxidable . negro. negro boton plano",
          "primaryAsset": "miss-v68-n13-primary.webp",
          "alternateAsset": "miss-v68-n13-alternate.webp"
        }
      ]
    },
    {
      "model": "flower",
      "style": "elegantes flores",
      "audience": "adulto nina",
      "shaft": "1,2",
      "order": 17,
      "variants": [
        {
          "sku": "F09",
          "name": "Zircon Flower",
          "displayName": "Zircon Flower · Flower · Crystal",
          "color": "Crystal",
          "colorTerms": "cristal dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#E4E9EE",
          "material": "oro24k",
          "millimetres": "4",
          "publicCents": 2000,
          "expo": false,
          "expoOrder": 999,
          "search": "f09 flor circonita flor cristal flor 4 mm. acero inoxidable . laminado en oro 24k. cristal. oro 24k flor",
          "primaryAsset": "miss-v68-f09-primary.webp",
          "alternateAsset": "miss-v68-f09-alternate.webp"
        },
        {
          "sku": "14FP",
          "name": "Valeria Flower",
          "displayName": "Valeria Flower · Flower · Aurora Borealis",
          "color": "Aurora Borealis",
          "colorTerms": "cristal dorado multicolor rosa",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "conic-gradient(from 210deg,#F3BCC8,#F7E5A6,#C3E5CB,#BCDAF1,#DAC7EE,#F3BCC8)",
          "material": "oro24k",
          "millimetres": "4",
          "publicCents": 2000,
          "expo": true,
          "expoOrder": 1,
          "search": "14fp flor valeria flor aurora boreal flor 4 mm. acero inoxidable . laminado en oro 24k. petalos rosa. centro cristal. oro 24k flor",
          "primaryAsset": "miss-v68-14fp-primary.webp",
          "alternateAsset": "miss-v68-14fp-alternate.webp"
        },
        {
          "sku": "14FB",
          "name": "Celestial Flower",
          "displayName": "Light Blue Flower · Flower · Aquamarine",
          "color": "Aquamarine",
          "colorTerms": "azul cristal dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#86CFE6",
          "material": "oro24k",
          "millimetres": "4",
          "publicCents": 2000,
          "expo": true,
          "expoOrder": 2,
          "search": "14fb flor celeste flor aguamarina flor 4 mm. acero inoxidable . laminado en oro 24k. petalos aguamarina. centro cristal. oro 24k flor",
          "primaryAsset": "miss-v68-14fb-primary.webp",
          "alternateAsset": "miss-v68-14fb-alternate.webp"
        },
        {
          "sku": "F21",
          "name": "Boreal Flower",
          "displayName": "Boreal Flower · Flower · Aurora Borealis",
          "color": "Aurora Borealis",
          "colorTerms": "dorado multicolor",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "conic-gradient(from 210deg,#F3BCC8,#F7E5A6,#C3E5CB,#BCDAF1,#DAC7EE,#F3BCC8)",
          "material": "oro24k",
          "millimetres": "5",
          "publicCents": 2000,
          "expo": false,
          "expoOrder": 999,
          "search": "f21 flor boreal flor aurora boreal flor 5 mm. acero inoxidable . laminado en oro 24k. aurora boreal. oro 24k flor",
          "primaryAsset": "miss-v68-f21-primary.webp",
          "alternateAsset": "miss-v68-f21-alternate.webp"
        }
      ]
    },
    {
      "model": "Flat Butterfly",
      "style": "animales",
      "audience": "nina",
      "shaft": "1,2",
      "order": 18,
      "variants": [
        {
          "sku": "14BT",
          "name": "Gala Butterfly",
          "displayName": "Gala Butterfly · Flat Butterfly · Golden",
          "color": "Gold",
          "colorTerms": "dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#C9A254",
          "material": "oro24k",
          "millimetres": "6",
          "publicCents": 2000,
          "expo": true,
          "expoOrder": 19,
          "search": "14bt mariposa gala mariposa dorado mariposa plana 6 mm. acero inoxidable . laminado en oro 24k. oro 24k mariposa plana",
          "primaryAsset": "miss-v68-14bt-primary.webp",
          "alternateAsset": "miss-v68-14bt-alternate.webp"
        }
      ]
    },
    {
      "model": "Smooth Heart",
      "style": "corazones",
      "audience": "nina",
      "shaft": "1,2",
      "order": 19,
      "variants": [
        {
          "sku": "H10",
          "name": "Heart Amélie",
          "displayName": "Amélie Heart Smooth Heart Golden",
          "color": "Gold",
          "colorTerms": "dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#C9A254",
          "material": "oro24k",
          "millimetres": "6",
          "publicCents": 2000,
          "expo": false,
          "expoOrder": 999,
          "search": "h10 corazon amelie corazon dorado corazon liso 6 mm. acero inoxidable . laminado en oro 24k. oro 24k corazon liso",
          "primaryAsset": "miss-v68-h10-primary.webp",
          "alternateAsset": "miss-v68-h10-alternate.webp"
        }
      ]
    },
    {
      "model": "crystal star",
      "style": "elegantes estrellas",
      "audience": "adulto nina",
      "shaft": "1,2",
      "order": 20,
      "variants": [
        {
          "sku": "E01",
          "name": "North Star",
          "displayName": "Polar Star Crystal Star Crystal",
          "color": "Crystal",
          "colorTerms": "cristal plateado",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#E4E9EE",
          "material": "acero",
          "millimetres": "5",
          "publicCents": 1800,
          "expo": false,
          "expoOrder": 999,
          "search": "e01 estrella polar estrella cristal estrella cristal 5 mm. acero inoxidable . cristal. plateado estrella cristal",
          "primaryAsset": "miss-v68-e01-primary.webp",
          "alternateAsset": "miss-v68-e01-alternate.webp"
        }
      ]
    },
    {
      "model": "Flat Heart",
      "style": "corazones elegantes",
      "audience": "adulto nina",
      "shaft": "1,2",
      "order": 21,
      "variants": [
        {
          "sku": "14H",
          "name": "Heart Soul",
          "displayName": "Heart Soul · Flat Heart · Golden",
          "color": "Gold",
          "colorTerms": "cristal dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#C9A254",
          "material": "oro24k",
          "millimetres": "4",
          "publicCents": 2000,
          "expo": true,
          "expoOrder": 3,
          "search": "14h corazon alma corazon dorado corazon plano 4 mm. acero inoxidable . laminado en oro 24k. circonita cubica. cristal. oro 24k corazon plano",
          "primaryAsset": "miss-v68-14h-primary.webp",
          "alternateAsset": "miss-v68-14h-alternate.webp"
        }
      ]
    },
    {
      "model": "Embossed Heart",
      "style": "corazones elegantes",
      "audience": "adulto nina",
      "shaft": "1,2",
      "order": 22,
      "variants": [
        {
          "sku": "H14",
          "name": "Zircon Heart",
          "displayName": "Zircon Heart · Embossed Heart · Golden",
          "color": "Gold",
          "colorTerms": "cristal dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#C9A254",
          "material": "oro24k",
          "millimetres": "4",
          "publicCents": 2000,
          "expo": false,
          "expoOrder": 999,
          "search": "h14 corazon circonita corazon dorado corazon relieve 4 mm. acero inoxidable . laminado en oro 24k. circonita cubica. cristal. oro 24k corazon relieve",
          "primaryAsset": "miss-v68-h14-primary.webp",
          "alternateAsset": "miss-v68-h14-alternate.webp"
        }
      ]
    },
    {
      "model": "Mini Star",
      "style": "estrellas",
      "audience": "nina",
      "shaft": "1,2",
      "order": 23,
      "variants": [
        {
          "sku": "24S",
          "name": "Moon Star",
          "displayName": "Moon Star · Mini Star · Silver",
          "color": "Silver",
          "colorTerms": "plateado",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#C4C9CF",
          "material": "acero",
          "millimetres": "4",
          "publicCents": 1800,
          "expo": true,
          "expoOrder": 25,
          "search": "24s estrella lunar estrella plateado estrella mini 4 mm. acero inoxidable . plateado. plateado estrella mini",
          "primaryAsset": "miss-v68-24s-primary.webp",
          "alternateAsset": "miss-v68-24s-alternate.webp"
        }
      ]
    },
    {
      "model": "Star Plane",
      "style": "estrellas",
      "audience": "nina",
      "shaft": "1,2",
      "order": 24,
      "variants": [
        {
          "sku": "14S",
          "name": "Star Vega",
          "displayName": "Vega Star · Plane Star · Gold",
          "color": "Gold",
          "colorTerms": "dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#C9A254",
          "material": "oro24k",
          "millimetres": "4",
          "publicCents": 2000,
          "expo": true,
          "expoOrder": 4,
          "search": "14s estrella vega estrella dorado estrella plano 4 mm. acero inoxidable . laminado en oro 24k. oro 24k estrella plano",
          "primaryAsset": "miss-v68-14s-primary.webp",
          "alternateAsset": "miss-v68-14s-alternate.webp"
        }
      ]
    },
    {
      "model": "Relief Star",
      "style": "elegantes estrellas",
      "audience": "adulto nina",
      "shaft": "1,2",
      "order": 25,
      "variants": [
        {
          "sku": "E17",
          "name": "Zircon Star",
          "displayName": "Zircon Star · Relief Star · Golden",
          "color": "Gold",
          "colorTerms": "cristal dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#C9A254",
          "material": "oro24k",
          "millimetres": "4",
          "publicCents": 2000,
          "expo": false,
          "expoOrder": 999,
          "search": "e17 estrella circonita estrella dorado estrella relieve 4 mm. acero inoxidable . laminado en oro 24k. circonita cubica. cristal. oro 24k estrella relieve",
          "primaryAsset": "miss-v68-e17-primary.webp",
          "alternateAsset": "miss-v68-e17-alternate.webp"
        }
      ]
    },
    {
      "model": "Lotus Flower",
      "style": "flores",
      "audience": "nina",
      "shaft": "1,2",
      "order": 26,
      "variants": [
        {
          "sku": "24F",
          "name": "Serena Lotus",
          "displayName": "Serena Lotus · Lotus Flower · Silver",
          "color": "Silver",
          "colorTerms": "plateado",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#C4C9CF",
          "material": "acero",
          "millimetres": "4",
          "publicCents": 1800,
          "expo": true,
          "expoOrder": 35,
          "search": "24f loto serena flor plateado flor loto 4 mm. acero inoxidable .plateado. plateado flor loto",
          "primaryAsset": "miss-v68-24f-primary.webp",
          "alternateAsset": "miss-v68-24f-alternate.webp"
        }
      ]
    },
    {
      "model": "Classic Ball",
      "style": "basicos bolas",
      "audience": "bebe",
      "shaft": "0,9",
      "order": 27,
      "variants": [
        {
          "sku": "1B",
          "name": "Sun",
          "displayName": "Sun · Classic Ball · Golden",
          "color": "Gold",
          "colorTerms": "dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#C9A254",
          "material": "oro24k",
          "millimetres": "3",
          "publicCents": 2000,
          "expo": true,
          "expoOrder": 41,
          "search": "1b sol esfera dorado esfera clasica 3 mm. acero inoxidable . laminado en oro 24k. bebe/lobulo fino oro 24k esfera clasica",
          "primaryAsset": "miss-v68-1b-primary.webp",
          "alternateAsset": "miss-v68-1b-alternate.webp"
        }
      ]
    },
    {
      "model": "Classic Ball",
      "style": "basicos bolas",
      "audience": "bebe",
      "shaft": "0,9",
      "order": 28,
      "variants": [
        {
          "sku": "2B",
          "name": "Moon",
          "displayName": "Moon · Classic Ball · Silver",
          "color": "Silver",
          "colorTerms": "plateado",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#C4C9CF",
          "material": "acero",
          "millimetres": "3",
          "publicCents": 1800,
          "expo": true,
          "expoOrder": 45,
          "search": "2b luna esfera plateado esfera clasica 3 mm. acero inoxidable . bebe/lobulo fino plateado esfera clasica",
          "primaryAsset": "miss-v68-2b-primary.webp",
          "alternateAsset": "miss-v68-2b-alternate.webp"
        }
      ]
    },
    {
      "model": "Bezel Mini",
      "style": "basicos elegantes",
      "audience": "bebe",
      "shaft": "0,9",
      "order": 29,
      "variants": [
        {
          "sku": "1C",
          "name": "Sun Flash",
          "displayName": "Sun Flash · Mini Bezel · Crystal",
          "color": "Crystal",
          "colorTerms": "cristal dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#E4E9EE",
          "material": "oro24k",
          "millimetres": "3",
          "publicCents": 2000,
          "expo": true,
          "expoOrder": 42,
          "search": "1c destello sol bezel cristal bezel mini 3 mm. acero inoxidable . laminado en oro 24k. cristal. bebe/lobulo fino oro 24k bezel mini",
          "primaryAsset": "miss-v68-1c-primary.webp",
          "alternateAsset": "miss-v68-1c-alternate.webp"
        },
        {
          "sku": "1CB",
          "name": "Sky Flash",
          "displayName": "Sky Flash Bezel Mini Aquamarine",
          "color": "Aquamarine",
          "colorTerms": "azul dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#86CFE6",
          "material": "oro24k",
          "millimetres": "3",
          "publicCents": 2000,
          "expo": true,
          "expoOrder": 44,
          "search": "1cb destello cielo bezel aguamarina bezel mini 3 mm. acero inoxidable . laminado en oro 24k. aguamarina. bebe/lobulo fino oro 24k bezel mini",
          "primaryAsset": "miss-v68-1cb-primary.webp",
          "alternateAsset": "miss-v68-1cb-alternate.webp"
        },
        {
          "sku": "1CP",
          "name": "Rosé Flash",
          "displayName": "Rosé Flash Bezel Mini Pink",
          "color": "Pink",
          "colorTerms": "dorado rosa",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#F09AB9",
          "material": "oro24k",
          "millimetres": "3",
          "publicCents": 2000,
          "expo": true,
          "expoOrder": 43,
          "search": "1cp destello rose bezel rosa bezel mini 3 mm. acero inoxidable . laminado en oro 24k. rosa. bebe/lobulo fino oro 24k bezel mini",
          "primaryAsset": "miss-v68-1cp-primary.webp",
          "alternateAsset": "miss-v68-1cp-alternate.webp"
        }
      ]
    },
    {
      "model": "Bezel Mini",
      "style": "basicos elegantes",
      "audience": "bebe",
      "shaft": "0,9",
      "order": 30,
      "variants": [
        {
          "sku": "2C",
          "name": "Moon Flash",
          "displayName": "Moon Flash · Mini Bezel · Crystal",
          "color": "Crystal",
          "colorTerms": "cristal plateado",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#E4E9EE",
          "material": "acero",
          "millimetres": "3",
          "publicCents": 1800,
          "expo": true,
          "expoOrder": 46,
          "search": "2c destello luna bezel cristal bezel mini 3 mm. acero inoxidable . circonita cubica. cristal. bebe/lobulo fino plateado bezel mini",
          "primaryAsset": "miss-v68-2c-primary.webp",
          "alternateAsset": "miss-v68-2c-alternate.webp"
        },
        {
          "sku": "2CB",
          "name": "Sky Droplet",
          "displayName": "Sky Droplet · Bezel Mini · Aquamarine",
          "color": "Aquamarine",
          "colorTerms": "azul plateado",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#86CFE6",
          "material": "acero",
          "millimetres": "3",
          "publicCents": 1800,
          "expo": true,
          "expoOrder": 47,
          "search": "2cb gotita cielo bezel aguamarina bezel mini 3 mm. acero inoxidable . circonita cubica. aguamarina. bebe/lobulo fino plateado bezel mini",
          "primaryAsset": "miss-v68-2cb-primary.webp",
          "alternateAsset": "miss-v68-2cb-alternate.webp"
        },
        {
          "sku": "2CP",
          "name": "Pink Droplet",
          "displayName": "Pink Droplet Bezel Mini Pink",
          "color": "Pink",
          "colorTerms": "plateado rosa",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#F09AB9",
          "material": "acero",
          "millimetres": "3",
          "publicCents": 1800,
          "expo": true,
          "expoOrder": 48,
          "search": "2cp gotita rosa bezel rosa bezel mini 3 mm. acero inoxidable . circonita cubica. rosa. bebe/lobulo fino plateado bezel mini",
          "primaryAsset": "miss-v68-2cp-primary.webp",
          "alternateAsset": "miss-v68-2cp-alternate.webp"
        }
      ]
    },
    {
      "model": "Button",
      "style": "basicos elegantes",
      "audience": "bebe",
      "shaft": "0,9",
      "order": 31,
      "variants": [
        {
          "sku": "N04",
          "name": "Moon Zircon",
          "displayName": "Zircon Moon · Button · Crystal",
          "color": "Crystal",
          "colorTerms": "cristal plateado",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#E4E9EE",
          "material": "acero",
          "millimetres": "4",
          "publicCents": 1800,
          "expo": false,
          "expoOrder": 999,
          "search": "n04 circonita luna boton cristal boton 4 mm. acero inoxidable . circonitas cubicas. cristal. bebe/lobulo fino. plateado boton",
          "primaryAsset": "miss-v68-n04-primary.webp",
          "alternateAsset": "miss-v68-n04-alternate.webp"
        }
      ]
    },
    {
      "model": "Disk",
      "style": "basicos elegantes",
      "audience": "bebe",
      "shaft": "0,9",
      "order": 32,
      "variants": [
        {
          "sku": "N06",
          "name": "Alba Zircon",
          "displayName": "Alba Zircon · Disc · Crystal",
          "color": "Crystal",
          "colorTerms": "cristal dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#E4E9EE",
          "material": "oro24k",
          "millimetres": "4",
          "publicCents": 2000,
          "expo": false,
          "expoOrder": 999,
          "search": "n06 circonita alba boton cristal disco 4 mm. acero inoxidable . laminado en oro 24k. cristal. bebe/lobulo fino. oro 24k disco",
          "primaryAsset": "miss-v68-n06-primary.webp",
          "alternateAsset": "miss-v68-n06-alternate.webp"
        },
        {
          "sku": "N07",
          "name": "Rose Zircon",
          "displayName": "Rosé Zircon · Disc · Pink",
          "color": "Pink",
          "colorTerms": "dorado rosa",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#F09AB9",
          "material": "oro24k",
          "millimetres": "4",
          "publicCents": 2000,
          "expo": false,
          "expoOrder": 999,
          "search": "n07 circonita rose boton rosa disco 4 mm. acero inoxidable . laminado en oro 24k. rosa. bebe/lobulo fino. oro 24k disco",
          "primaryAsset": "miss-v68-n07-primary.webp",
          "alternateAsset": "miss-v68-n07-alternate.webp"
        }
      ]
    },
    {
      "model": "Minimal Bar",
      "style": "basicos geometricos",
      "audience": "adulto",
      "shaft": "1,2",
      "order": 33,
      "variants": [
        {
          "sku": "A01",
          "name": "Line",
          "displayName": "Line · Minimal Bar · Gold",
          "color": "Gold",
          "colorTerms": "dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#C9A254",
          "material": "oro24k",
          "millimetres": "8",
          "publicCents": 2000,
          "expo": false,
          "expoOrder": 999,
          "search": "a01 linea barra dorado barra minimal 8 mm. acero inoxidable . laminado en oro 24k. oro 24k barra minimal",
          "primaryAsset": "miss-v68-a01-primary.webp",
          "alternateAsset": "miss-v68-a01-alternate.webp"
        }
      ]
    },
    {
      "model": "Classic 4-claw solitaire",
      "style": "basicos elegantes solitario",
      "audience": "adulto",
      "shaft": "1,2",
      "order": 34,
      "variants": [
        {
          "sku": "12S",
          "name": "Mini Solitaire",
          "displayName": "Mini Solitaire Classic 4-claw Solitaire Crystal",
          "color": "Crystal",
          "colorTerms": "cristal dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#E4E9EE",
          "material": "oro24k",
          "millimetres": "2",
          "publicCents": 2000,
          "expo": true,
          "expoOrder": 5,
          "search": "12s solitario mini solitario cristal solitario clasico 4 garras 2mm. laminado en oro 24k . circonita cubica. cristal. oro 24k solitario clasico 4 garras",
          "primaryAsset": "miss-v68-12s-primary.webp",
          "alternateAsset": "miss-v68-12s-alternate.webp"
        },
        {
          "sku": "12SP",
          "name": "Solitaire Dew",
          "displayName": "Rocío Solitaire · Classic 4-claw solitaire · Pink",
          "color": "Pink",
          "colorTerms": "dorado rosa",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#F09AB9",
          "material": "oro24k",
          "millimetres": "2",
          "publicCents": 2000,
          "expo": true,
          "expoOrder": 7,
          "search": "12sp rosa mini solitario rosa solitario clasico 4 garras 2mm. laminado en oro 24k . circonita cubica. rosa. oro 24k solitario clasico 4 garras",
          "primaryAsset": "miss-v68-12sp-primary.webp",
          "alternateAsset": "miss-v68-12sp-alternate.webp"
        },
        {
          "sku": "13S",
          "name": "Solitaire Dawn",
          "displayName": "Alba Solitaire · Classic 4-claw solitaire · Crystal",
          "color": "Crystal",
          "colorTerms": "cristal dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#E4E9EE",
          "material": "oro24k",
          "millimetres": "3",
          "publicCents": 2000,
          "expo": true,
          "expoOrder": 6,
          "search": "13s solitario alba solitario cristal solitario clasico 4 garras 3 mm. acero inoxidable . laminado en oro 24k. circonita cubica. cristal. engaste abierto. oro 24k solitario clasico 4 garras",
          "primaryAsset": "miss-v68-13s-primary.webp",
          "alternateAsset": "miss-v68-13s-alternate.webp"
        },
        {
          "sku": "13SB",
          "name": "Aqua Solitaire",
          "displayName": "Aqua Solitaire Classic 4-claw Solitaire Aquamarine",
          "color": "Aquamarine",
          "colorTerms": "azul dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#86CFE6",
          "material": "oro24k",
          "millimetres": "3",
          "publicCents": 2000,
          "expo": true,
          "expoOrder": 11,
          "search": "13sb solitario aqua solitario aguamarina solitario clasico 4 garras 3 mm. acero inoxidable . laminado en oro 24k. circonita cubica. aguamarina. engaste abierto. oro 24k solitario clasico 4 garras",
          "primaryAsset": "miss-v68-13sb-primary.webp",
          "alternateAsset": "miss-v68-13sb-alternate.webp"
        },
        {
          "sku": "13SP",
          "name": "Aurora Solitaire",
          "displayName": "Aurora Solitaire Classic 4-claw Solitaire Pink",
          "color": "Pink",
          "colorTerms": "dorado rosa",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#F09AB9",
          "material": "oro24k",
          "millimetres": "3",
          "publicCents": 2000,
          "expo": true,
          "expoOrder": 8,
          "search": "13sp rosa clasica solitario rosa solitario clasico 4 garras 3mm. laminado en oro 24k . circonita cubica.rosa. oro 24k solitario clasico 4 garras",
          "primaryAsset": "miss-v68-13sp-primary.webp",
          "alternateAsset": "miss-v68-13sp-alternate.webp"
        },
        {
          "sku": "S50",
          "name": "Ruby Solitaire",
          "displayName": "Ruby Solitaire · Classic 4-claw solitaire · Ruby",
          "color": "ruby",
          "colorTerms": "dorado rojo",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#A5182F",
          "material": "oro24k",
          "millimetres": "3",
          "publicCents": 2000,
          "expo": false,
          "expoOrder": 999,
          "search": "s50 solitario rubi solitario rubi solitario clasico 4 garras 3 mm. laminado en oro 24k. rojo rubi. oro 24k solitario clasico 4 garras",
          "primaryAsset": "miss-v68-s50-primary.webp",
          "alternateAsset": "miss-v68-s50-alternate.webp"
        },
        {
          "sku": "S51",
          "name": "Peridot Solitaire",
          "displayName": "Peridot Solitaire · Classic 4-claw solitaire · Peridot",
          "color": "Peridot",
          "colorTerms": "dorado verde",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#9FCB3B",
          "material": "oro24k",
          "millimetres": "3",
          "publicCents": 2000,
          "expo": false,
          "expoOrder": 999,
          "search": "s51 solitario peridoto solitario peridoto solitario clasico 4 garras 3 mm. laminado en oro 24k. verde peridoto. oro 24k solitario clasico 4 garras",
          "primaryAsset": "miss-v68-s51-primary.webp",
          "alternateAsset": "miss-v68-s51-alternate.webp"
        },
        {
          "sku": "14SP",
          "name": "Solitaire Light",
          "displayName": "Light Solitaire · Classic 4-claw solitaire · Crystal",
          "color": "Crystal",
          "colorTerms": "cristal dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#E4E9EE",
          "material": "oro24k",
          "millimetres": "4",
          "publicCents": 2000,
          "expo": true,
          "expoOrder": 12,
          "search": "14sp solitario luz solitario cristal solitario clasico 4 garras 4 mm. acero inoxidable . laminado en oro 24k. circonita cubica. cristal. oro 24k solitario clasico 4 garras",
          "primaryAsset": "miss-v68-14sp-primary.webp",
          "alternateAsset": "miss-v68-14sp-alternate.webp"
        },
        {
          "sku": "S89",
          "name": "Pink Solitaire",
          "displayName": "Pink Solitaire Classic 4-claw Solitaire Pink",
          "color": "Pink",
          "colorTerms": "dorado rosa",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#F09AB9",
          "material": "oro24k",
          "millimetres": "4",
          "publicCents": 2000,
          "expo": false,
          "expoOrder": 999,
          "search": "s89 rosa grande solitario rosa solitario clasico 4 garras 4 mm. acero inoxidable . laminado en oro 24k. circonita cubica. rosa. oro 24k solitario clasico 4 garras",
          "primaryAsset": "miss-v68-s89-primary.webp",
          "alternateAsset": "miss-v68-s89-alternate.webp"
        },
        {
          "sku": "S76",
          "name": "Emerald Solitaire",
          "displayName": "Emerald Solitaire · Classic 4-claw solitaire · Emerald Green",
          "color": "Emerald Green",
          "colorTerms": "dorado verde",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#0F6B4A",
          "material": "oro24k",
          "millimetres": "4",
          "publicCents": 2000,
          "expo": false,
          "expoOrder": 999,
          "search": "s76 solitario esmeralda menta solitario verde esmeralda mayo piedra de nacimiento solitario clasico 4 garras 4 mm. acero inoxidable . laminado en oro 24k. circonita cubica. verde esmeralda. oro 24k solitario clasico 4 garras",
          "primaryAsset": "miss-v68-s76-primary.webp",
          "alternateAsset": "miss-v68-s76-alternate.webp"
        },
        {
          "sku": "S116",
          "name": "Aura Solitaire",
          "displayName": "Aura Solitaire · Classic 4-claw solitaire · Crystal",
          "color": "Crystal",
          "colorTerms": "cristal dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#E4E9EE",
          "material": "oro24k",
          "millimetres": "5",
          "publicCents": 2000,
          "expo": false,
          "expoOrder": 999,
          "search": "s116 alba radiante solitario cristal solitario clasico 6 garras 5 mm. acero inoxidable . circonita cubica. laminado en oro 24k. cristal. oro 24k solitario clasico 6 garras",
          "primaryAsset": "miss-v68-s116-primary.webp",
          "alternateAsset": "miss-v68-s116-alternate.webp"
        },
        {
          "sku": "S119",
          "name": "Lavender Solitaire",
          "displayName": "Lavender Solitaire · Classic 4-claw solitaire · Lavender",
          "color": "Lavender",
          "colorTerms": "azul dorado violeta",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#BCA7E6",
          "material": "oro24k",
          "millimetres": "5",
          "publicCents": 2000,
          "expo": false,
          "expoOrder": 999,
          "search": "s119 lavanda mistica solitario lavanda solitario clasico 6 garras 5 mm. acero inoxidable . circonita cubica. laminado en oro 24k. azul claro. oro 24k solitario clasico 6 garras",
          "primaryAsset": "miss-v68-s119-primary.webp",
          "alternateAsset": "miss-v68-s119-alternate.webp"
        },
        {
          "sku": "S118",
          "name": "Charming Solitaire",
          "displayName": "Charming Solitaire · Classic 4-claw solitaire · Pink",
          "color": "Pink",
          "colorTerms": "dorado rosa",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#F09AB9",
          "material": "oro24k",
          "millimetres": "5",
          "publicCents": 2000,
          "expo": false,
          "expoOrder": 999,
          "search": "s118 rosa encanto solitario rosa solitario clasico 6 garras 5 mm. acero inoxidable . circonita cubica. laminado en oro 24k. rosa. oro 24k solitario clasico 6 garras",
          "primaryAsset": "miss-v68-s118-primary.webp",
          "alternateAsset": "miss-v68-s118-alternate.webp"
        }
      ]
    },
    {
      "model": "Triangle",
      "style": "basicos geometricos",
      "audience": "adulto",
      "shaft": "1,2",
      "order": 35,
      "variants": [
        {
          "sku": "12V",
          "name": "Triangle",
          "displayName": "Triangle Triangle Steel",
          "color": "Steel",
          "colorTerms": "plateado",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#C4C9CF",
          "material": "acero",
          "millimetres": "5",
          "publicCents": 1800,
          "expo": true,
          "expoOrder": 36,
          "search": "12v triangulo triangulo acero triangulo 5 mm. acero inoxidable . plateado triangulo",
          "primaryAsset": "miss-v68-12v-primary.webp",
          "alternateAsset": "miss-v68-12v-alternate.webp"
        }
      ]
    },
    {
      "model": "Classic 4-claw solitaire",
      "style": "basicos elegantes solitario",
      "audience": "adulto",
      "shaft": "1,2",
      "order": 36,
      "variants": [
        {
          "sku": "22S",
          "name": "Solitaire Breeze",
          "displayName": "Brisa Solitaire · Classic 4-claw solitaire · Crystal",
          "color": "Crystal",
          "colorTerms": "cristal plateado",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#E4E9EE",
          "material": "acero",
          "millimetres": "2",
          "publicCents": 1800,
          "expo": true,
          "expoOrder": 26,
          "search": "22s luna mini solitario cristal solitario clasico 4 garras 2mm. acero inoxidable . circonita cubica. cristal. plateado solitario clasico 4 garras",
          "primaryAsset": "miss-v68-22s-primary.webp",
          "alternateAsset": "miss-v68-22s-alternate.webp"
        },
        {
          "sku": "23S",
          "name": "Solitaire Snow",
          "displayName": "Snow Solitaire · Classic 4-claw Solitaire · Crystal",
          "color": "Crystal",
          "colorTerms": "cristal plateado",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#E4E9EE",
          "material": "acero",
          "millimetres": "3",
          "publicCents": 1800,
          "expo": true,
          "expoOrder": 27,
          "search": "23s luna clasica solitario cristal solitario clasico 4 garras 3mm. acero inoxidable . circonita cubica. cristal. plateado solitario clasico 4 garras",
          "primaryAsset": "miss-v68-23s-primary.webp",
          "alternateAsset": "miss-v68-23s-alternate.webp"
        },
        {
          "sku": "23SB",
          "name": "Celestial Solitaire",
          "displayName": "Light Blue Solitaire Classic 4-claw Solitaire Blue Zircon",
          "color": "Zircon blue",
          "colorTerms": "azul plateado",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#3B87C8",
          "material": "acero",
          "millimetres": "3",
          "publicCents": 1800,
          "expo": true,
          "expoOrder": 32,
          "search": "23sb aqua solitario azul circon solitario clasico 4 garras 3 mm. acero inoxidable . diciembre. aguamarina. plateado solitario clasico 4 garras",
          "primaryAsset": "miss-v68-23sb-primary.webp",
          "alternateAsset": "miss-v68-23sb-alternate.webp"
        },
        {
          "sku": "23SP",
          "name": "Rosé Solitaire",
          "displayName": "Rosé Solitaire · Classic 4-claw solitaire · Pink",
          "color": "Pink",
          "colorTerms": "plateado rosa",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#F09AB9",
          "material": "acero",
          "millimetres": "3",
          "publicCents": 1800,
          "expo": true,
          "expoOrder": 31,
          "search": "23sp rosa lunar solitario rosa solitario clasico 4 garras 3mm. acero inoxidable . circonita cubica. rosa. plateado solitario clasico 4 garras",
          "primaryAsset": "miss-v68-23sp-primary.webp",
          "alternateAsset": "miss-v68-23sp-alternate.webp"
        },
        {
          "sku": "24SL",
          "name": "Moon Solitaire",
          "displayName": "Moon Solitaire Classic 4-claw Solitaire Crystal",
          "color": "Crystal",
          "colorTerms": "cristal plateado",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#E4E9EE",
          "material": "acero",
          "millimetres": "4",
          "publicCents": 1800,
          "expo": true,
          "expoOrder": 28,
          "search": "24sl luna boreal solitario cristal solitario clasico 4 garras 4mm. acero inoxidable . circonita cubica. cristal. plateado solitario clasico 4 garras",
          "primaryAsset": "miss-v68-24sl-primary.webp",
          "alternateAsset": "miss-v68-24sl-alternate.webp"
        },
        {
          "sku": "S110",
          "name": "Gala Solitaire",
          "displayName": "Gala Solitaire · Classic 4-claw solitaire · Crystal",
          "color": "Crystal",
          "colorTerms": "cristal plateado",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#E4E9EE",
          "material": "acero",
          "millimetres": "5",
          "publicCents": 1800,
          "expo": false,
          "expoOrder": 999,
          "search": "s110 solitario gala solitario cristal solitario clasico 6 garras 5 mm. acero inoxidable . circonita cubica. cristal. plateado solitario clasico 6 garras",
          "primaryAsset": "miss-v68-s110-primary.webp",
          "alternateAsset": "miss-v68-s110-alternate.webp"
        }
      ]
    },
    {
      "model": "smooth dial",
      "style": "basicos bolas",
      "audience": "adulto",
      "shaft": "1,2",
      "order": 37,
      "variants": [
        {
          "sku": "43B",
          "name": "Titanium Sphere",
          "displayName": "Titanium Dial Smooth Dial Silver",
          "color": "Silver",
          "colorTerms": "plateado titanio",
          "finish": "Titanium",
          "finishDot": "#9B7AC5",
          "swatch": "#C4C9CF",
          "material": "titanio",
          "millimetres": "3",
          "publicCents": 2200,
          "expo": true,
          "expoOrder": 37,
          "search": "43B Esfera Titanio Esfera lisa Plateado 3 mm titanio",
          "primaryAsset": "miss-v68-43b-primary.webp",
          "alternateAsset": "miss-v68-43b-alternate.webp"
        },
        {
          "sku": "B13",
          "name": "Indigo",
          "displayName": "Indigo · Smooth dial · Blue",
          "color": "Blue",
          "colorTerms": "azul titanio",
          "finish": "Titanium",
          "finishDot": "#9B7AC5",
          "swatch": "#2F6FBF",
          "material": "titanio",
          "millimetres": "3",
          "publicCents": 2200,
          "expo": false,
          "expoOrder": 999,
          "search": "b13 indigo esfera lisa azul 3 mm titanio",
          "primaryAsset": "miss-v68-b13-primary.webp",
          "alternateAsset": "miss-v68-b13-alternate.webp"
        }
      ]
    },
    {
      "model": "Classic Ball",
      "style": "basicos bolas",
      "audience": "adulto",
      "shaft": "1,2",
      "order": 38,
      "variants": [
        {
          "sku": "13B",
          "name": "Petite Ball",
          "displayName": "Petite Ball · Classic Ball · Golden",
          "color": "Gold",
          "colorTerms": "dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#C9A254",
          "material": "oro24k",
          "millimetres": "3",
          "publicCents": 2000,
          "expo": true,
          "expoOrder": 9,
          "search": "13b esfera petite esfera dorado esfera clasica 3 mm. acero inoxidable . laminado en oro 24k. dorado. oro 24k esfera clasica",
          "primaryAsset": "miss-v68-13b-primary.webp",
          "alternateAsset": "miss-v68-13b-alternate.webp"
        },
        {
          "sku": "33B",
          "name": "Rose Sphere",
          "displayName": "Rosé Dial · Classic Ball · Pink",
          "color": "Pink",
          "colorTerms": "dorado rosa",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#F09AB9",
          "material": "oro24k",
          "millimetres": "3",
          "publicCents": 2000,
          "expo": true,
          "expoOrder": 40,
          "search": "33b esfera rose esfera rosa esfera clasica 3 mm. acero inoxidable . laminado en oro rosa 24k. rosa. oro 24k esfera clasica",
          "primaryAsset": "miss-v68-33b-primary.webp",
          "alternateAsset": "miss-v68-33b-alternate.webp"
        },
        {
          "sku": "14B",
          "name": "Classic Ball",
          "displayName": "Classic Ball · Classic Ball · Golden",
          "color": "Gold",
          "colorTerms": "dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#C9A254",
          "material": "oro24k",
          "millimetres": "4",
          "publicCents": 2000,
          "expo": true,
          "expoOrder": 10,
          "search": "14b esfera clasica esfera dorado esfera clasica 4 mm. acero inoxidable . laminado en oro 24k. oro 24k esfera clasica",
          "primaryAsset": "miss-v68-14b-primary.webp",
          "alternateAsset": "miss-v68-14b-alternate.webp"
        }
      ]
    },
    {
      "model": "Classic Ball",
      "style": "basicos bolas",
      "audience": "adulto",
      "shaft": "1,2",
      "order": 39,
      "variants": [
        {
          "sku": "23B",
          "name": "Moon Sphere",
          "displayName": "Moon Dial · Classic Ball · Silver",
          "color": "Silver",
          "colorTerms": "plateado",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#C4C9CF",
          "material": "acero",
          "millimetres": "3",
          "publicCents": 1800,
          "expo": true,
          "expoOrder": 23,
          "search": "23b esfera luna esfera plateado esfera clasica 3 mm. acero inoxidable . plateado. plateado esfera clasica",
          "primaryAsset": "miss-v68-23b-primary.webp",
          "alternateAsset": "miss-v68-23b-alternate.webp"
        },
        {
          "sku": "23N",
          "name": "Petite Onyx",
          "displayName": "Petite Onyx · Classic Ball · Black",
          "color": "Black",
          "colorTerms": "negro",
          "finish": "Black",
          "finishDot": "#3A3A3A",
          "swatch": "#17171A",
          "material": "acero",
          "millimetres": "3",
          "publicCents": 1800,
          "expo": true,
          "expoOrder": 21,
          "search": "23n onix petite esfera negro esfera clasica 3 mm. acero inoxidable . negro. negro esfera clasica",
          "primaryAsset": "miss-v68-23n-primary.webp",
          "alternateAsset": "miss-v68-23n-alternate.webp"
        },
        {
          "sku": "24B",
          "name": "Serena",
          "displayName": "Serena · Classic Ball · Silver",
          "color": "Silver",
          "colorTerms": "plateado",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#C4C9CF",
          "material": "acero",
          "millimetres": "4",
          "publicCents": 1800,
          "expo": true,
          "expoOrder": 24,
          "search": "24b serena esfera plateado esfera clasica 4 mm. acero inoxidable . plateado. plateado esfera clasica",
          "primaryAsset": "miss-v68-24b-primary.webp",
          "alternateAsset": "miss-v68-24b-alternate.webp"
        }
      ]
    },
    {
      "model": "Bezel",
      "style": "basicos elegantes",
      "audience": "adulto",
      "shaft": "1,2",
      "order": 40,
      "variants": [
        {
          "sku": "Z10",
          "name": "Bezel Cloud",
          "displayName": "Cloud Bezel · Bezel · Crystal",
          "color": "Crystal",
          "colorTerms": "cristal plateado",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#E4E9EE",
          "material": "acero",
          "millimetres": "2",
          "publicCents": 1800,
          "expo": false,
          "expoOrder": 999,
          "search": "z10 bezel nube bezel cristal bezel mini 2 mm. acero inoxidable . cristal. plateado bezel mini",
          "primaryAsset": "miss-v68-z10-primary.webp",
          "alternateAsset": "miss-v68-z10-alternate.webp"
        },
        {
          "sku": "Z19",
          "name": "Lunar Bezel",
          "displayName": "Lunar Bezel · Bezel · Crystal",
          "color": "Crystal",
          "colorTerms": "cristal plateado",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#E4E9EE",
          "material": "acero",
          "millimetres": "3",
          "publicCents": 1800,
          "expo": false,
          "expoOrder": 999,
          "search": "z19 bezel lunar bezel cristal bezel 3 mm. acero inoxidable . cristal. plateado bezel",
          "primaryAsset": "miss-v68-z19-primary.webp",
          "alternateAsset": "miss-v68-z19-alternate.webp"
        },
        {
          "sku": "Z24",
          "name": "Sapphire Bezel",
          "displayName": "Sapphire Bezel · Bezel · Sapphire Blue",
          "color": "Sapphire Blue",
          "colorTerms": "azul plateado",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#24479E",
          "material": "acero",
          "millimetres": "3",
          "publicCents": 1800,
          "expo": false,
          "expoOrder": 999,
          "search": "z24 bezel zafiro bezel azul zafiro bezel 3 mm. acero inoxidable . azul zafiro. plateado bezel",
          "primaryAsset": "miss-v68-z24-primary.webp",
          "alternateAsset": "miss-v68-z24-alternate.webp"
        },
        {
          "sku": "Z47",
          "name": "Subtle Bezel",
          "displayName": "Subtle Bezel · Bezel · Crystal",
          "color": "Crystal",
          "colorTerms": "cristal plateado",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#E4E9EE",
          "material": "acero",
          "millimetres": "4",
          "publicCents": 1800,
          "expo": false,
          "expoOrder": 999,
          "search": "z47 bezel sutil bezel cristal bezel 4 mm. acero inoxidable . cristal. plateado bezel",
          "primaryAsset": "miss-v68-z47-primary.webp",
          "alternateAsset": "miss-v68-z47-alternate.webp"
        },
        {
          "sku": "Z49",
          "name": "Bezel Dream",
          "displayName": "Bezel Dream · Bezel · Tanzanite",
          "color": "Tanzanite",
          "colorTerms": "violeta plateado",
          "finish": "Silver",
          "finishDot": "#B9BDC4",
          "swatch": "#8B7BD4",
          "material": "acero",
          "millimetres": "4",
          "publicCents": 1800,
          "expo": false,
          "expoOrder": 999,
          "search": "z49 bezel ensueno bezel tanzanita bezel 4 mm. acero inoxidable . tanzanita. plateado bezel",
          "primaryAsset": "miss-v68-z49-primary.webp",
          "alternateAsset": "miss-v68-z49-alternate.webp"
        }
      ]
    },
    {
      "model": "Button",
      "style": "basicos",
      "audience": "adulto",
      "shaft": "1,2",
      "order": 41,
      "variants": [
        {
          "sku": "24N",
          "name": "Classic Onyx",
          "displayName": "Classic Onyx · Button · Jet",
          "color": "Jet",
          "colorTerms": "negro",
          "finish": "Black",
          "finishDot": "#3A3A3A",
          "swatch": "#1C1C1F",
          "material": "acero",
          "millimetres": "4",
          "publicCents": 1800,
          "expo": true,
          "expoOrder": 22,
          "search": "24n onix clasico boton azabache boton 4mm. acero inoxidable . negro. negro boton",
          "primaryAsset": "miss-v68-24n-primary.webp",
          "alternateAsset": "miss-v68-24n-alternate.webp"
        }
      ]
    },
    {
      "model": "Button Birthstone",
      "style": "basicos elegantes",
      "audience": "adulto",
      "shaft": "1,2",
      "order": 42,
      "variants": [
        {
          "sku": "44C",
          "name": "April Titanium",
          "displayName": "April Titanium Button Birthstone April Crystal",
          "color": "April Crystal",
          "colorTerms": "cristal plateado titanio",
          "finish": "Titanium",
          "finishDot": "#9B7AC5",
          "swatch": "#E4E9EE",
          "material": "titanio",
          "millimetres": "4",
          "publicCents": 2200,
          "expo": true,
          "expoOrder": 38,
          "search": "44C Abril Titanio Botón · Piedra de Nacimiento Abril · Cristal 4 mm titanio",
          "primaryAsset": "miss-v68-44c-primary.webp",
          "alternateAsset": "miss-v68-44c-alternate.webp"
        }
      ]
    },
    {
      "model": "Modern Pearl",
      "style": "basicos perlas",
      "audience": "adulto",
      "shaft": "1,2",
      "order": 43,
      "variants": [
        {
          "sku": "12P",
          "name": "Mini Pearl",
          "displayName": "Mini Pearl Modern Pearl Pearl",
          "color": "Pearl",
          "colorTerms": "dorado perla",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#F0E6DA",
          "material": "oro24k",
          "millimetres": "2.5",
          "publicCents": 2000,
          "expo": true,
          "expoOrder": 15,
          "search": "12p perla mini perla perla perla moderna 2,5 mm. acero inoxidable . laminado en oro 24k. perla. oro 24k perla moderna",
          "primaryAsset": "miss-v68-12p-primary.webp",
          "alternateAsset": "miss-v68-12p-alternate.webp"
        },
        {
          "sku": "13P",
          "name": "Modern Pearl",
          "displayName": "Modern Pearl Modern Pearl Pearl",
          "color": "Pearl",
          "colorTerms": "dorado perla",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#F0E6DA",
          "material": "oro24k",
          "millimetres": "3.5",
          "publicCents": 2000,
          "expo": true,
          "expoOrder": 16,
          "search": "13p perla moderna perla perla perla moderna 3,5 mm. acero inoxidable . laminado en oro 24k. perla. oro 24k perla moderna",
          "primaryAsset": "miss-v68-13p-primary.webp",
          "alternateAsset": "miss-v68-13p-alternate.webp"
        }
      ]
    },
    {
      "model": "Classic Pearl",
      "style": "basicos perlas",
      "audience": "adulto",
      "shaft": "1,2",
      "order": 44,
      "variants": [
        {
          "sku": "12C",
          "name": "Classic Pearl",
          "displayName": "Classic Pearl Classic Pearl Pearl",
          "color": "Pearl",
          "colorTerms": "dorado perla",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#F0E6DA",
          "material": "oro24k",
          "millimetres": "3",
          "publicCents": 2000,
          "expo": true,
          "expoOrder": 14,
          "search": "12c perla clasica perla perla perla clasica 3 mm. acero inoxidable . laminado en oro 24k perla. oro 24k perla clasica",
          "primaryAsset": "miss-v68-12c-primary.webp",
          "alternateAsset": "miss-v68-12c-alternate.webp"
        }
      ]
    },
    {
      "model": "4 Claws Solitaire",
      "style": "basicos elegantes solitario",
      "audience": "adulto",
      "shaft": "1,2",
      "order": 45,
      "variants": [
        {
          "sku": "44S",
          "name": "Titanium Solitaire",
          "displayName": "Titanium Solitaire · 4 Claws Solitaire · Crystal",
          "color": "Crystal",
          "colorTerms": "cristal plateado titanio",
          "finish": "Titanium",
          "finishDot": "#9B7AC5",
          "swatch": "#E4E9EE",
          "material": "titanio",
          "millimetres": "4",
          "publicCents": 2200,
          "expo": true,
          "expoOrder": 39,
          "search": "44S Solitario Titanio Solitario 4 Garras Cristal 4 mm titanio",
          "primaryAsset": "miss-v68-44s-primary.webp",
          "alternateAsset": "miss-v68-44s-alternate.webp"
        }
      ]
    },
    {
      "model": "Bezel",
      "style": "basicos elegantes",
      "audience": "adulto",
      "shaft": "1,2",
      "order": 46,
      "variants": [
        {
          "sku": "Z14",
          "name": "Bezel Honey",
          "displayName": "Bezel Honey · Bezel · Crystal",
          "color": "Crystal",
          "colorTerms": "cristal dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#E4E9EE",
          "material": "oro24k",
          "millimetres": "2",
          "publicCents": 2000,
          "expo": false,
          "expoOrder": 999,
          "search": "z14 bezel miel bezel cristal bezel mini 2 mm. acero inoxidable . laminado en oro 24k. cristal. oro 24k bezel mini",
          "primaryAsset": "miss-v68-z14-primary.webp",
          "alternateAsset": "miss-v68-z14-alternate.webp"
        },
        {
          "sku": "Z33",
          "name": "Solar Bezel",
          "displayName": "Solar Bezel · Bezel · Crystal",
          "color": "Crystal",
          "colorTerms": "cristal dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#E4E9EE",
          "material": "oro24k",
          "millimetres": "3",
          "publicCents": 2000,
          "expo": false,
          "expoOrder": 999,
          "search": "z33 bezel solar bezel cristal bezel 3 mm. acero inoxidable . laminado en oro 24k. cristal. oro 24k bezel",
          "primaryAsset": "miss-v68-z33-primary.webp",
          "alternateAsset": "miss-v68-z33-alternate.webp"
        },
        {
          "sku": "Z61",
          "name": "Bezel Frost",
          "displayName": "Frosted Bezel · Bezel · Crystal",
          "color": "Crystal",
          "colorTerms": "cristal dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#E4E9EE",
          "material": "oro24k",
          "millimetres": "4",
          "publicCents": 2000,
          "expo": false,
          "expoOrder": 999,
          "search": "z61 bezel helada bezel cristal bezel 4 mm. acero inoxidable . laminado en oro 24k. cristal. oro 24k bezel",
          "primaryAsset": "miss-v68-z61-primary.webp",
          "alternateAsset": "miss-v68-z61-alternate.webp"
        }
      ]
    },
    {
      "model": "Flower Bouquet",
      "style": "flores elegantes",
      "audience": "adulto nina",
      "shaft": "1,2",
      "order": 47,
      "variants": [
        {
          "sku": "F55",
          "name": "Flower Bouquet",
          "displayName": "Flower Bouquet Crystal",
          "color": "Crystal",
          "colorTerms": "cristal dorado",
          "finish": "24K Gold",
          "finishDot": "#C9A254",
          "swatch": "#E4E9EE",
          "material": "oro24k",
          "millimetres": "8",
          "publicCents": 2000,
          "expo": false,
          "expoOrder": 999,
          "search": "f55 flor bouquet cristal 8 mm acero inoxidable laminado en oro 24k circonita cubica",
          "primaryAsset": "miss-v68-f55-primary.webp",
          "alternateAsset": "miss-v68-f55-alternate.webp"
        }
      ]
    }
  ]
};
  const catalog = window.MissEarringsCatalog;
  const identicalSizeFamilies = [
    ["14FP", "F21"],
    ["13B", "14B"], ["23B", "24B"], ["12P", "13P"],
    ["12S", "13S", "14SP"], ["22S", "23S", "24SL", "S110"], ["12SP", "13SP"],
    ["Z10", "Z19", "Z47"], ["Z14", "Z33", "Z61"]
  ];
  const sizeFamilyBySku = new Map();
  identicalSizeFamilies.forEach(function (skus, index) {
    skus.forEach(function (sku) { sizeFamilyBySku.set(sku, index); });
  });
  catalog.groups = catalog.groups.flatMap(function (group) {
    return group.variants.map(function (variant) {
      return Object.assign({}, group, { variants: [variant] });
    });
  });
  const sizeGroups = new Map();
  catalog.groups = catalog.groups.filter(function (group) {
    if (group.variants.length !== 1) return true;
    const variant = group.variants[0];
    if (!sizeFamilyBySku.has(variant.sku)) return true;
    const family = sizeFamilyBySku.get(variant.sku);
    if (!sizeGroups.has(family)) {
      sizeGroups.set(family, group);
      return true;
    }
    sizeGroups.get(family).variants.push(variant);
    return false;
  });
  const babyFlowerSkus = new Set(["N04", "N06", "N07"]);
  catalog.groups.forEach(function (group, index) {
    group.order = index;
    if (group.variants.some(function (variant) { return babyFlowerSkus.has(variant.sku); })) {
      group.style = Array.from(new Set((group.style + " flores").split(/\s+/))).join(" ");
    }
  });
  catalog.groupCount = catalog.groups.length;
})();

(function(c){var additions=[{model:'Garnet Enamel Heart',style:'corazones',audience:'adulto nina',variants:[{sku:'15HG',name:'Garnet Heart',displayName:'Garnet Heart · 4 mm',color:'Garnet',colorTerms:'granate rojo dorado',finish:'24K Gold',finishDot:'#C9A254',swatch:'#800020',material:'oro24k',millimetres:'4',publicCents:1790,expo:false,expoOrder:999,search:'15HG corazon granate esmaltado rojo 4 mm oro 24k'}]},{model:'Fine Bow',style:'elegantes originales',audience:'adulto nina',variants:[{sku:'L01',name:'Golden Bow',displayName:'Golden Bow · 7 mm',color:'Gold',colorTerms:'dorado',finish:'24K Gold',finishDot:'#C9A254',swatch:'#C9A254',material:'oro24k',millimetres:'7',publicCents:1790,expo:false,expoOrder:999,search:'L01 lazo fino dorado 7 mm oro 24k'}]}];additions.forEach(function(g){var sku=g.variants[0].sku;if(c.approvedSkus.indexOf(sku)<0){g.order=c.groups.length;c.groups.push(g);c.approvedSkus.push(sku);}});c.groupCount=c.groups.length;c.skuCount=c.approvedSkus.length;})(window.MissEarringsCatalog);

